import { AnalyticsService } from '../../services/analytics/analytics.service';
import { HttpService } from '../../services/http/http.service';
import { z } from 'zod';
import { ApiResponseSchema } from '../api-response';
import { ApiSchema } from '../api-schema';
import { CheckpointsData, CheckpointsSchema } from './schemas/checkpoints';
import { GameStatesData, GameStatesSchema } from './schemas/game-states';

export const DEALER_ENDPOINTS = {
  CHECKPOINTS: 'checkpoints',
  GAME_STATES: 'game-states',
} as const;

export class DealerApi {
  private api: ApiSchema;

  private constructor(url: string, httpService: HttpService, analyticsService: AnalyticsService) {
    this.api = new ApiSchema(url, httpService, analyticsService);
  }

  public static request(url: string, httpService: HttpService, analyticsService: AnalyticsService) {
    return new DealerApi(url, httpService, analyticsService);
  }

  public async gameStates(dealId: string): Promise<GameStatesData> {
    const GameStatesResponseSchema = ApiResponseSchema(GameStatesSchema);
    type GameStatesResponse = z.infer<typeof GameStatesResponseSchema>;

    const response = await this.api.get<GameStatesResponse>(
      `${DEALER_ENDPOINTS.GAME_STATES}/${dealId}`,
      GameStatesResponseSchema,
    );
    return response.data;
  }

  public async checkpoints(
    dealId: string,
    gameStateHash: string,
    prevCheckpointId: string | null,
    moves: string[],
    disclosures: number[],
  ): Promise<CheckpointsData> {
    const CheckpointsResponseSchema = ApiResponseSchema(CheckpointsSchema);
    type CheckpointsResponse = z.infer<typeof CheckpointsResponseSchema>;

    const response = await this.api.post<
      CheckpointsResponse,
      {
        dealId: string;
        gameStateHash: string;
        prevCheckpointId: string | null;
        moves: string[];
        disclosures: number[];
      }
    >(
      DEALER_ENDPOINTS.CHECKPOINTS,
      CheckpointsResponseSchema,
      {
        dealId,
        gameStateHash,
        prevCheckpointId,
        moves,
        disclosures,
      },
      [2000],
    );

    return response.data;
  }
}
